/** The `<main>` every layout gives this id (with `tabIndex={-1}`, so the skip link can focus it). */
export const MAIN_CONTENT_ID = "main-content";

/**
 * "Skip to main content": the first focusable element of every layout, hidden until it is focused,
 * so keyboard and screen-reader users can jump past the navigation.
 */
export function SkipLink() {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="sr-only rounded-lg bg-surface px-4 py-2.5 text-sm font-semibold text-fg shadow-lg ring-2 ring-brand-500 focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] print:hidden"
    >
      Skip to main content
    </a>
  );
}
